import {PayloadAction} from '@reduxjs/toolkit';
//types
import {
	IAttentionItem,
	IAttentionList,
	IOrganizationDashboardAuctionItemsResponse,
	IOrganizationDashboardCheckedInResponse,
	IOrganizationDashboardReducer,
	IOrganizationDashboardSpecialMealsResponse,
	IOrganizationDashboardStatistics,
	IOrganizationDashboardTablesSoldResponse,
	IOrganizationDashboardUnknownGuestsResponse,
} from '../../utils/types';

export const pendingOperation = (state: IOrganizationDashboardReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IOrganizationDashboardReducer) => {
	state.isLoading = false;
};

export const getStatisticsOperation = (
	state: IOrganizationDashboardReducer,
	{payload}: PayloadAction<IOrganizationDashboardStatistics>
) => {
	state.statistics = payload;
	state.isLoading = false;
};

export const getDashboardTablesSoldOperation = (
	state: IOrganizationDashboardReducer,
	{payload}: PayloadAction<IOrganizationDashboardTablesSoldResponse>
) => {
	state.tablesSold = payload;
	state.isLoading = false;
};

export const getDashboardUnknownGuestsOperation = (
	state: IOrganizationDashboardReducer,
	{payload}: PayloadAction<IOrganizationDashboardUnknownGuestsResponse>
) => {
	state.unknownGuests = payload;
	state.isLoading = false;
};

export const getDashboardAuctionItemsOperation = (
	state: IOrganizationDashboardReducer,
	{payload}: PayloadAction<IOrganizationDashboardAuctionItemsResponse>
) => {
	state.auctionItems = payload;
	state.isLoading = false;
};

export const getDashboardCheckedInOperation = (
	state: IOrganizationDashboardReducer,
	{payload}: PayloadAction<IOrganizationDashboardCheckedInResponse>
) => {
	state.checkedIn = payload;
	state.isLoading = false;
};

export const getDashboardSpecialMealsOperation = (
	state: IOrganizationDashboardReducer,
	{payload}: PayloadAction<IOrganizationDashboardSpecialMealsResponse>
) => {
	state.specialMeals = payload;
	state.isLoading = false;
};

export const clearDashboardDataOperation = (
	state: IOrganizationDashboardReducer,
	initialState: IOrganizationDashboardReducer
) => {
	Object.assign(state, initialState);
};

export const getDashboardAttentionListDataOperation = (
	state: IOrganizationDashboardReducer,
	{payload}: PayloadAction<IAttentionItem[] | []>
) => {
	state.attentionList = payload;
	state.isLoading = false;
};
